import { encryptedPost } from '@iso/lib/helpers/resApiEncryptedRequestor';
import { fetch, get, post, putOtp } from '@iso/lib/helpers/resApiRequestor';
import { 
  clearCustomAuth, clearCustomModule, clearDisabledModules, 
  clearEnv, clearForbidToken, clearIdentity, clearMerchantFees, 
  clearMerchantList, clearModules, clearMqttToken, clearRoles, 
  clearSelectedMerchant, clearSelectedMerchantName, clearStores, 
  clearToken, clearTopic, getCustomAuth, getCustomModule, getDisabledModules, 
  getEnv, getForbidToken, getIdentity, getMerchantFees, getModules, getMqttToken, 
  getRoles, getSelectedMerchant, getSelectedMerchantName, getToken, getTopic, 
  getStores, clearLta } from '@iso/lib/helpers/utility';
import { all, fork, put, select, takeEvery, take } from 'redux-saga/effects';
import { eventChannel } from "redux-saga";

import { createBrowserHistory } from 'history';
import dashBoardAction from '../dashboard/actions';
import mqttAction from '../mqtt/actions';
import actions from './actions';
import merchantAction from '../merchant/actions';
// import { AuthorizedPut } from '@iso/lib/helpers/resApiRequestorAuth';
import { pushDataToApp } from '@iso/lib/helpers/mobileAppCommKit';
import trxAction from '../transactions/actions';
import { kotlinApiGet, kotlinApiPost, kotlinApiPut } from '@iso/lib/helpers/resKotlinApiRequestor';
import { kotlinApiEncryptedGet } from '@iso/lib/helpers/resKotlinApiEncryptedRequestor';
import SSEManager from '../../library/sse/SSEManager';

const history = createBrowserHistory();
const apiUrl = process.env.REACT_APP_API_URL;
const systemId = process.env.REACT_APP_SYSTEM_ID;
let headers = {
  'Accept': 'application/json',
  'Content-Type': 'application/json',
};

export function* loginRequest() {
  yield takeEvery('LOGIN_REQUEST', function* ({ payload }) {
    try {
      yield put({
        type: actions.KICKED_OUT_CLEAR,
      });
      yield put({
        type: actions.CLEAR_ERROR,
      });
      yield put({
        type: actions.SET_LOADING,
        loading: true,
      });
      // const token = false;
      // try {
      const apiResult = yield login(payload);
      if (apiResult) {
        const result = apiResult.data ? apiResult.data : apiResult;
        if (result.success) {
            if(result.data.user.is_temp_password) {
              yield put({
                type: actions.SET_IS_UPDATE_PASSWORD,
                payload: {
                  isUpdatePassword: true,
                  username: result.data.user.username,
                },
              })
              yield put({
                type: actions.SET_LOADING,
                loading: false,
              });
              return
            }
            const authValue = result.data.user.role.authorizations;
            let formattedAuthorization = [];
            let formattedModuleId = {};
            for (let i = 0; i < authValue.length; i++) {
              const element = authValue[i];
              formattedModuleId[element.moduleId] = element;
            }
            formattedAuthorization.push(formattedModuleId);
            const apiResultRoles = yield fetchAllRoles(result.data.token);
            const resultRoles = apiResultRoles.data;
            const moduleResult = yield fetchModules(result.data.token);
            const modResult = moduleResult.data;
            yield put({
              type: dashBoardAction.RESET_DASHBOARD_DATA,
            });
            const disabledModulesResult = yield fetchDisabledModules(result.data.user.tenantId);
            let disabledModules = disabledModulesResult.data.success && disabledModulesResult.data.data.length > 0 ? disabledModulesResult.data.data : null;
            // const disabledModules = null;
            if (result.data.user.role.role.label === 'Store Admin' || result.data.user.role.role.label === 'Store User') {
              const financials = {
                alias: 'FINANCIALS',
                category: 'Module'
              };
              if (disabledModules) {
                disabledModules.push(financials);
              } else {
                disabledModules[0] = financials;
              }
            }
  
            let merchantFees;
            if (result.data.user.merchantId) {
              if (result.data.user.role.role.label !== 'Administrator' || result.data.user.role.role.label !== 'Finance' || result.data.user.role.role.label !== 'Sales') {
                merchantFees = yield fetchFeesByTenantMid(result.data.user.merchantId, result.data.token);
                merchantFees = merchantFees.status === 200 && merchantFees.data.success ? merchantFees.data.data.result : null;
              } else {
                merchantFees = yield fetchFeesByTenant(result.data.token);
                merchantFees = merchantFees.status === 200 && merchantFees.data.success ? merchantFees.data.data.result : null;
              }
            }
  
            if (modResult.success) {
              let formattedModule = [];
              let formatteElement = {};
              let allMerchant = [];
              let modulesData = modResult.data.result[0].submodules;
              // THIS LOGIC IS USER FOR REMOVING BATCHUPLOAD IF THE RECORD IN MERCHANT SETTINGS IS FALSE
              if (!result?.data?.user?.merchantSettings?.isBatchUpload) {
                modulesData = modulesData.filter((el) => {
                  if (el.alias === 'TOOLS') {
                    el.submodules = el.submodules.filter((elB) => {
                      return elB.alias !== 'MERCHANT_BATCH_UPLOAD';
                    });
                  }
                  return el;
                });
              }
              for (let i = 0; i < modulesData.length; i++) {
                const element = modulesData[i];
                formatteElement[element.alias] = element;
              }
              formattedModule.push(formatteElement);
              const role = result.data.user.role.role.label;
              if (role !== 'Finance' && role !== 'Sales') {
                if (role === 'Paynamics Agent' && modulesData) {
                  modulesData = modulesData.filter((el) => {
                    if (el.alias === 'CORPORATE_MERCHANT') {
                      el.submodules = el.submodules.filter((elB) => {
                        return elB.alias === 'MERCHANT_REFERRAL';
                      });
                    }
                    return el;
                  });
                }
                const storesResult = yield fetchStores(result.data.token, result.data.user.merchantId)
                // let selectedMerchant = '';
                // let selectedMerchantName = ''
                if (storesResult.status === 200) {
                  let topic;
                  if (role === 'Store Admin' || role === 'Store User' || role === 'Ticket Seller' || role === 'Shipping Seller' || role === 'Conductor') {
                    topic = `/lambda-transaction-${process.env.REACT_APP_TOPIC_ENV}-${storesResult.data[0].storeId}`;
                    // selectedMerchantName = result?.data?.user?.merchantInfo?.legalName;
                    // selectedMerchant = result?.data?.user?.merchantInfo?.merchantId;
                  } else if (role === 'Merchant Admin' || role === 'Paynamics Agent' || role === 'Cashier' || role === 'Audit') {
                    topic = `/lambda-transaction-${process.env.REACT_APP_TOPIC_ENV}-${result.data.user.merchantId}`;
                    pushDataToApp('merchant_id', result.data.user.merchantId);
                    const mobileTopic = `/lambda-mobiletrx-${result.data.user.merchantId}`;
                    pushDataToApp('android_topic', mobileTopic);
                    // selectedMerchantName = result?.data?.user?.merchantInfo?.legalName;
                    // selectedMerchant = result?.data?.user?.merchantInfo?.merchantId;
                  } else if (role === 'Administrator' || role === 'Finance' || role === 'Sales') {
                    allMerchant = yield fetchAllMerchant(result.data.token);
                    allMerchant = allMerchant.data.data.result;
                    // selectedMerchantName = 'All Merchant';
                    // selectedMerchant = 'All Merchant';
                  } else if (role === 'Corporate View') {
                    allMerchant = yield fetchSubMerchants(result.data.user.Id, result.data.token);
                    allMerchant = allMerchant.data.data.result;
                    // selectedMerchantName = 'All Merchant';
                    // selectedMerchant = 'All Merchant';
                  }
                  yield put({
                    type: actions.SUBMODULES,
                    payload: modResult.data.result[0].submodules,
                  });
                  yield put({
                    type: actions.LOGIN_SUCCESS,
                    token: result.data.token,
                    identity: JSON.stringify(result.data.user),
                    stores: storesResult.data ? storesResult.data : null,
                    // modules: JSON.stringify(modResult.data.result[0].submodules),
                    modules: JSON.stringify(modulesData),
                    merchantId: result.data.user.merchantId,
                    customAuthorizations: JSON.stringify(formattedAuthorization[0]),
                    customModules: JSON.stringify(formattedModule[0]),
                    roles: JSON.stringify(resultRoles.data),
                    profile: 'Profile',
                    topic: topic,
                    env: result.data.env,
                    merchantList: JSON.stringify(allMerchant),
                    selectedMerchant: 'All Merchant',
                    selectedMerchantName: 'All Merchant',
                    disabledModules: disabledModules && disabledModules.length > 0 ? JSON.stringify(disabledModules) : null,
                    merchantFees: merchantFees && merchantFees.length > 0 ? JSON.stringify(merchantFees) : null
                  });

                  yield put({
                    type: mqttAction.CONNECT_MQTT,
                  });
                  if (role === 'Pre Registered') {
                    yield put({
                      type: trxAction.LOAD_PROVINCE,
                    });
                  }
                  // GET DASHBOARD COUNT
                  // yield put({
                  //   type: dashBoardAction.LOADED_DASHBOARD_DATA,
                  //   payload: null,
                  // });
                  if (role === 'Merchant Admin' || role === 'Store Admin' || role === 'Store User') {
                    const level = result?.data?.user?.merchantInfo?.riskProfileInfo?.profileName
                    if (["Business Level 0", "Business Level 1"].includes(level)) {
                      yield put({
                        type: actions.SET_IS_KYB_MODAL_OPEN,
                        payload: true
                      });
                    }
                  }
                  yield put({
                    type: actions.SET_LOADING,
                    loading: false,
                  });
                } else {
                  yield put({
                    type: actions.LOGIN_ERROR,
                    error: 'Cannot get store information',
                  });
                }
              } else {
                allMerchant = yield fetchAllMerchant(result.data.token);
                allMerchant = allMerchant.data.data.result;
                let topic;
                yield put({
                  type: actions.SUBMODULES,
                  payload: modResult.data.result[0].submodules,
                });
                yield put({
                  type: actions.LOGIN_SUCCESS,
                  token: result.data.token,
                  identity: JSON.stringify(result.data.user),
                  modules: JSON.stringify(modResult.data.result[0].submodules),
                  merchantId: result.data.user.merchantId,
                  customAuthorizations: JSON.stringify(formattedAuthorization[0]),
                  customModules: JSON.stringify(formattedModule[0]),
                  roles: JSON.stringify(resultRoles.data),
                  profile: 'Profile',
                  topic: topic,
                  env: result.data.env,
                  merchantList: JSON.stringify(allMerchant),
                  selectedMerchant: 'All Merchant',
                  selectedMerchantName: 'All Merchant',
                  disabledModules: disabledModules && disabledModules.length > 0 ? JSON.stringify(disabledModules) : null,
                  merchantFees: merchantFees && merchantFees.length > 0 ? JSON.stringify(merchantFees) : null,
                });
                yield put({
                  type: mqttAction.CONNECT_MQTT,
                });
                if (role === 'Pre Registered') {
                  yield put({
                    type: trxAction.LOAD_PROVINCE,
                  });
                }
                if (role === 'Merchant Admin' || role === 'Store Admin' || role === 'Store User') {
                  const level = result?.data?.user?.merchantInfo?.riskProfileInfo?.profileName
                  if (["Business Level 0", "Business Level 1"].includes(level)) {
                    yield put({
                      type: actions.SET_IS_KYB_MODAL_OPEN,
                      payload: true
                    });
                  }
                }
                yield put({
                  type: actions.SET_LOADING,
                  loading: false,
                });
              }
            }

            // Call SSE listen function
            yield fork(listenToSSE);
            
        } else {
          let errorResponse = '';
          if (result && result.message === 'Unauthorized') {
            errorResponse = 'INVALID_AUTH';
          } else if (result && result.message === 'Account not verified') {
            errorResponse = 'NOT_VERIFIED';
          } else if (result && result.message === 'Account Locked') {
            errorResponse = 'ACCOUNT_LOCKED';
          } else if (result && result.message === 'Password Expired') {
            errorResponse = 'PASSWORD_EXPIRED';
          } else if (result && result.message === 'Forbidden') {
            errorResponse = 'FORBIDDEN';
          } else if (result?.response_message === 'Invalid OTP') {
            errorResponse = 'INVALID_OTP';
          } else {
            errorResponse = 'Login Error';
          }
          yield put({
            type: actions.LOGIN_ERROR,
            error: errorResponse,
          });
          yield put({
            type: actions.SET_LOADING,
            loading: false,
          });
        }
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: 'Login Error',
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
      }
    } catch (e) {
      yield put({
        type: actions.LOGIN_ERROR,
        error: 'Login Error',
      });
      yield put({
        type: actions.SET_LOADING,
        loading: false,
      });
    }
    // } catch (e) {
    //   yield put({
    //     type: actions.LOGIN_ERROR,
    //     error: e.message.indexOf('Network') > -1 ? 'NETWORK_ERROR' : 'INVALID_AUTH',
    //   });
    //   yield put({
    //     type: actions.SET_LOADING,
    //     loading: false,
    //   });
    // }
  });
}
export function* signupRequest() {
  yield takeEvery('SIGNUP', function* ({ payload }) {
    yield put({
      type: actions.CLEAR_ERROR,
    });
    yield put({
      type: actions.SET_LOADING,
      loading: true,
    });
    // const token = false;
    try {
      const apiResult = yield signup(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
        yield put({
          type: actions.CLEAR_ERROR,
        });
        window.location.href = result.url;
      } else {
        yield put({
          type: actions.SIGNUP_ERROR,
          error: `Registration failed. ${result.message}`,
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
      }
    } catch (e) {
      yield put({
        type: actions.SIGNUP_ERROR,
        error: 'Registration failed',
      });
      yield put({
        type: actions.SET_LOADING,
        loading: false,
      });
    }
  });
}

export function* forgotPassword() {
  yield takeEvery('FORGOT_PASSWORD', function* ({ email }) {
    yield put({
      type: actions.CLEAR_ERROR,
    });
    yield put({
      type: actions.SET_LOADING,
      loading: true,
    });
    // const token = false;
    try {
      const apiResult = yield forgotPasswordReq(email);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FORGOT_ERROR,
          error: null,
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
        yield put({
          type: actions.FORGOT_PASSWORD_DONE,
          success: true,
        });
      } else {
        yield put({
          type: actions.FORGOT_PASSWORD_DONE,
          success: false,
        });
        yield put({
          type: actions.FORGOT_ERROR,
          error: result.data,
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
      }
    } catch (e) {
      yield put({
        type: actions.SET_LOADING,
        loading: false,
      });
    }
  });
}

export function* agreeOtp() {
  yield takeEvery('SAVE_AGREE_OTP', function* ({payload}) {
      try {
        yield put({
          type: actions.SAVING_AGREE_OTP,
        });
        const userId = payload.userId;
        const state = yield select();
        const token = state.Auth.otpAuthToken;
        const apiResult = yield saveAgreeOtp(userId, payload, token);
        const result = apiResult.data;   
        if (result) {
          yield put({
            type: actions.SAVED_AGREE_OTP,
            payload: result.data,
          });
          const state = yield select();
          const loginData = state.Auth.loginData;
          yield put({
            type: actions.REQUEST_LOGIN_OTP,
            payload: loginData,
          });
        } else {
          yield put({
            type: actions.SAVE_AGREE_OTP_FAILED,
          });
        }
      } catch (error) {
        yield put({
          type: actions.SAVING_AGREE_OTP,
          message: 'Error in saving agree otp!'
        });
      }
  });
}
export function* changeMerchant() {
  yield takeEvery('CHANGE_MERCHANT', function* ({ payload }) {
    const state = yield select();
    const role = state.Auth.identity.role.role.label;
    const token = state.Auth.idToken;
    const merchantId = role !== 'Administrator' && role !== 'Corporate View' && role !== 'Corporate View' && role !== 'Sales' && role !== 'Finance' ? state.Auth.identity.merchantId : payload.id;
    const storesResult = yield fetchStores(token, merchantId);
    if (storesResult.status === 200 || storesResult.status === 204) {
      yield put({
        type: actions.CHANGE_MERCHANT_SUCCESS,
        selectedMerchant: payload.id,
        selectedMerchantName: payload.name,
        stores: storesResult.data ? JSON.stringify(storesResult.data) : null,
      });
    }
  });
}
export function* fetchStore() {
  yield takeEvery('FETCH_STORES', function* () {
    const state = yield select();
    // const role = state.Auth.identity.role.role.label;
    const token = state.Auth.idToken;
    const merchantId = state.Auth.identity.merchantId;
    const storesResult = yield fetchStores(token, merchantId);
    if (storesResult.status === 200 || storesResult.status === 204) {
      yield put({
        type: actions.FETCH_STORES_SUCCESS,
        stores: storesResult.data ? JSON.stringify(storesResult.data) : null,
      });
    }
  });
}

export function* fetchStoreDataV2() {
  yield takeEvery('FETCH_STORES_V2', function* () {
    try {
      yield put({
        type: actions.FETCHING_STORES_V2,
      });
      const state = yield select();
      const role = state.Auth.identity.role.role.label;
      const token = state.Auth.idToken;
      // const merchantId = state.Auth.identity.merchantId;
      const merchantId = role !== 'Administrator' && role !== 'Corporate View' && role !== 'Sales' && role !== 'Finance' ? state.Auth.identity.merchantId : state.Auth.selectedMerchant;
      const storesResult = yield fetchStores(token, merchantId);
      if (merchantId && merchantId !== 'All Merchant') {
        if (storesResult.status === 200 || storesResult.status === 204) {
            yield put({
              type: actions.FETCHED_STORES_V2,
              stores: storesResult.data ? JSON.stringify(storesResult.data) : null,
            });
          } else {
            yield put({
              type: actions.FETCH_STORES_FAILED_V2,
            });
        }
      }
    } catch (e) {
      yield put({
        type: actions.FETCH_STORES_FAILED_V2,
      });
    }
  });
}

export function* searchStoreData() {
  yield takeEvery('SEARCH_STORE_DATA', function* (payload) {
    try {
      yield put({
        type: actions.SEARCHING_STORE_DATA,
      });
      const state = yield select();
      const role = state.Auth.identity.role.role.label;
      const token = state.Auth.idToken;
      // const merchantId = state.Auth.identity.merchantId;
      const merchantId = role !== 'Administrator' && role !== 'Corporate View' && role !== 'Sales' && role !== 'Finance' ? state.Auth.identity.merchantId : state.Auth.selectedMerchant;
      const storesResult = yield searchStores(payload.payload, token, merchantId);
      if (storesResult.status === 200 || storesResult.status === 204) {
        yield put({
          type: actions.SEARCHED_STORE_DATA,
          stores: storesResult.data || [],
        });
      } else {
        yield put({
          type: actions.SEARCH_STORE_DATA_FAILED,
        });
      }
    } catch (e) {
      yield put({
        type: actions.SEARCH_STORE_DATA_FAILED,
      });
    }
  });
}

export function* resendRegistrationEmail() {
  yield takeEvery('RESEND_REGISTRATION_EMAIL', function* ({ payload }) {
    try {
      yield put({
        type: actions.SENDING_REGISTRATION_EMAIL,
      });
      const apiResult = yield resendSuccesRegEmail(payload);
      if (apiResult.status === 200) {
        yield put({
          type: actions.SENT_REGISTRATION_EMAIL,
          payload: 'Email successfully sent',
        });
      } else {
        yield put({
          type: actions.RESEND_REGISTRATION_EMAIL_FAILED,
          payload: 'Failed to send email',
        });
      }
    } catch (e) {
      yield put({
        type: actions.RESEND_REGISTRATION_EMAIL_FAILED,
        payload: 'Failed to resend email',
      });
    }
  });
}

export function* resendRegistrationBatchUploadEmail() {
  yield takeEvery('RESEND_REGISTRATION_BATCH_UPLOAD_EMAIL', function* ({ payload }) {
    try {
      yield put({
        type: actions.SENDING_REGISTRATION_BATCH_UPLOAD_EMAIL,
      });
      const apiResult = yield resendSuccesBatchUploadRegEmail(payload);
      const result = apiResult.data;
      if (result.success) {
        // yield delay(2000);
        yield put({
          type: actions.SENT_REGISTRATION_BATCH_UPLOAD_EMAIL,
          payload: 'Email successfully resend',
        });
      } else {
        // yield delay(2000);
        yield put({
          type: actions.RESEND_REGISTRATION_EMAIL_BATCH_UPLOAD_FAILED,
          payload: 'Failed to resend email',
        });
      }
    } catch (e) {
      yield put({
        type: actions.RESEND_REGISTRATION_EMAIL_BATCH_UPLOAD_FAILED,
        payload: 'Failed to resend email',
      });
    }
  });
}

export function* loginSuccess() {
  yield takeEvery(actions.LOGIN_SUCCESS, function* (payload) {
    yield localStorage.setItem('idToken', payload.token);
    yield localStorage.setItem('modules', payload.modules);
    yield localStorage.setItem('identity', payload.identity);
    const stores = payload.stores?.length ? JSON.stringify([payload.stores[0]]) : getStores().get('stores');
    yield localStorage.setItem('stores', stores);
    yield localStorage.setItem('topic', payload.topic);
    yield localStorage.setItem('env', payload.env);
    yield localStorage.setItem('customAuthorizations', payload.customAuthorizations);
    yield localStorage.setItem('customModules', payload.customModules);
    yield localStorage.setItem('roles', payload.roles);
    // yield localStorage.setItem('merchantList', payload.merchantList);
    yield localStorage.setItem('selectedMerchant', payload.selectedMerchant);
    yield localStorage.setItem('selectedMerchantName', payload.selectedMerchantName);
    yield localStorage.setItem('disabledModules', payload.disabledModules);
    yield localStorage.setItem('merchantFees', payload.merchantFees);
    pushDataToApp('idToken', payload.token);
    pushDataToApp('modules', payload.modules);
    pushDataToApp('identity', payload.identity);
    pushDataToApp('stores', stores);
    pushDataToApp('topic', payload.topic);
    pushDataToApp('env', payload.env);
    pushDataToApp('customAuthorizations', payload.customAuthorizations);
    pushDataToApp('customModules', payload.customModules);
    pushDataToApp('roles', payload.roles);
    // pushDataToApp('merchantList', payload.merchantList);
    pushDataToApp('selectedMerchant', payload.selectedMerchant);
    pushDataToApp('selectedMerchantName', payload.selectedMerchantName);
    pushDataToApp('disabledModules', payload.disabledModules);
    pushDataToApp('merchantFees', payload.merchantFees);

    const lastTimeActivity = localStorage.getItem('lta');
    if(!lastTimeActivity) {
      const lta = lastTimeActivity || new Date().getTime().toString();
      yield localStorage.setItem('lta', lta);
      pushDataToApp('lta', lta);
    }
  });
}

export function* changeMerchantSuccess() {
  yield takeEvery(actions.CHANGE_MERCHANT_SUCCESS, function* (payload) {
    yield localStorage.setItem('selectedMerchant', payload.selectedMerchant);
    yield localStorage.setItem('selectedMerchantName', payload.selectedMerchantName);
    pushDataToApp('selectedMerchant', payload.selectedMerchant);
    pushDataToApp('selectedMerchantName', payload.selectedMerchantName);
    // yield put({
    //   type: actions.RESET_SECOND_TIMER,
    //   secondTimer: 900,
    // });
  });
}

export function* subModuleLoad() {
  yield takeEvery(actions.SUBMODULES, function* (data) {
    yield localStorage.setItem('modules', typeof data.payload === 'string' ? JSON.parse(data.payload) : data.payload);
  });
}

export function* loginError() {
  yield takeEvery(actions.LOGIN_ERROR, function* () { });
}

export function* logout() {
  yield takeEvery(actions.LOGOUT, function* () {
    yield clearToken();
    yield clearModules();
    yield clearIdentity();
    yield clearStores();
    yield clearTopic();
    yield clearEnv();
    yield clearMqttToken();
    yield clearCustomAuth();
    yield clearCustomModule();
    yield clearForbidToken();
    yield clearRoles();
    yield clearMerchantList();
    yield clearSelectedMerchant();
    yield clearSelectedMerchantName();
    yield clearDisabledModules();
    yield clearMerchantFees();
    yield clearLta();
    yield put({
      type: actions.RESET_SECOND_TIMER,
      secondTimer: 0,
    });
    history.push('/');

    const sse = SSEManager.getInstance();
    sse.disconnect();
  });
}
export function* kickedOutClear() {
  yield takeEvery(actions.KICKED_OUT_CLEAR, function* () {
    yield clearForbidToken();
  });
}
export function* checkAuthorization() {

  yield takeEvery(actions.CHECK_AUTHORIZATION, function* () {

    const forbidToken = getForbidToken().get('forbidToken');
    const token = getToken().get('idToken');
    const modules = getModules().get('modules');
    const identity = getIdentity().get('identity');
    const topic = getTopic().get('topic');
    const env = getEnv().get('env');
    const mqttToken = getMqttToken().get('mqttToken');
    const customAuthorizations = getCustomAuth().get('customAuthorizations');
    const customModules = getCustomModule().get('customModules');
    const roles = getRoles().get('roles');
    // const merchantList = getMerchantList().get('merchantList');
    const selectedMerchant = getSelectedMerchant().get('selectedMerchant');
    const selectedMerchantName = getSelectedMerchantName().get('selectedMerchantName');
    const disabledModules = getDisabledModules().get('disabledModules');
    const merchantFees = getMerchantFees().get('merchantFees');
    if (token) {
      yield put({
        type: actions.LOGIN_SUCCESS,
        token,
        identity,
        modules,
        profile: 'Profile',
        topic,
        env,
        customAuthorizations,
        customModules,
        roles,
        // merchantList,
        selectedMerchant,
        selectedMerchantName,
        disabledModules,
        merchantFees,
      });
      const identityJson = JSON.parse(identity)
      const role = identityJson?.role?.role?.label;
      const userId = identityJson?.Id;
      let allMerchant = [];
      if (role === 'Administrator' || role === 'Finance' || role === 'Sales') {
        const result = yield fetchAllMerchant();
        allMerchant = result.data.data.result;
      } else if (role === 'Corporate View') {
        const result = yield fetchSubMerchants(userId);
        allMerchant = result.data.data.result;
      }
      yield put({
        type: actions.SET_MERCHANT_LIST,
        payload: allMerchant,
      })
      yield put({
        type: actions.LOGIN_VALIDATOR,
        token: mqttToken,
      });
      yield put({
        type: mqttAction.CONNECT_MQTT,
      });
      // yield put({
      //   type: actions.SUBMODULES,
      //   payload: JSON.parse(modules),
      // });
    }
    // Call SSE listen function
    yield fork(listenToSSE);
    if (forbidToken) {
      yield put({
        type: actions.KICKED_OUT,
      });
      yield put({
        type: actions.LOGOUT,
      });
    }
  });
}

export function* getRedirectUrl() {
  yield takeEvery('FETCH_REDIRECT_URL', function* () {
    try {
      const apiResult = yield fetchRedirectUrl();
      const result = apiResult.data;
      yield put({
        type: actions.FETCHING_REDIRECT_URL,
      });
      yield put({
        type: actions.FETCHED_REDIRECT_URL,
        redirectUrl: result.redirect_login,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_REDIRECT_URL_FAILED,
      });
    }
  });
}

export function* getResetPassUrl() {
  yield takeEvery('FETCH_RESET_PASSWORD_URL', function* () {
    try {
      const apiResult = yield fetchResetPassUrl();
      const result = apiResult.data;
      yield put({
        type: actions.FETCHING_RESET_PASSWORD_URL,
      });
      yield put({
        type: actions.FETCHED_RESET_PASSWORD_URL,
        resetPassUrl: result,
      });
    } catch (error) {
      yield put({
        type: actions.FETCH_RESET_PASSWORD_URL_FAILED,
      });
    }
  });
}
export function* verifyOtp() {
  yield takeEvery('VALIDATE_OTP', function* ({payload}) {
    try {
      yield put({
        type: actions.VALIDATING_OTP,
      });
      const state = yield select();
      const otpData = state.Auth.otpData;
      const loginData = state.Auth.loginData;
      const verifyPayload = {
        username: loginData.username,
        password: loginData.password,
        otp: payload.otp,
        token: payload.token,
      };
      const apiResult = yield verifyingOtp(verifyPayload);
      const result = apiResult.data;
      if (apiResult) {
        if (result.success) {
          yield put({
            type: actions.VALIDATED_OTP,
            payload: result,
            isErrorVerifyOtp: false,
            verifyOtpMessage: result.message,
            otpModal: false,
          });

          if(result.is_temp_password) {
            yield put({
              type: actions.SET_IS_UPDATE_PASSWORD,
              payload: {
                isUpdatePassword: true,
                username: loginData.username,
              },
            })
            yield put({
              type: actions.SET_LOADING,
              loading: false,
            });
          } else {
            yield put({
              type: actions.LOGIN_REQUEST,
              payload: loginData,
            });
            yield put({
              type: actions.CLEAR_OTP_DATA,
            });
          }
        } else {
          let closeModal = true;
          let limitReachMessage = null;
          if (payload.otpAttempts > otpData.otp_attempts) {
            closeModal = false;
            limitReachMessage = true;
            result.message = null;
          }
          yield put({
            type: actions.VALIDATED_OTP,
            payload: result,
            verifyOtpMessage: result.message,
            isErrorVerifyOtp: true,
            otpModal: closeModal,
            limitReachMessage,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CLEAR_OTP_DATA,
      });
    }
  });
}

export function* resendLoginOtp() {
  yield takeEvery('RESEND_LOGIN_OTP', function* () {
    try {
      yield put({
        type: actions.RESENDING_LOGIN_OTP,
        payload: true,
        isErrorVerifyOtp: false, 
      });
      const state = yield select();
      // const token = state.Auth.otpAuthToken;
      const resendData = state.Auth.loginData;
      const apiResult = yield resendingOtp(resendData);
      const result = apiResult.data;
      if (result.success) {
        const message = `OTP successfully sent to ${result.data.email}`;
        yield put({
          type: actions.REQUESTED_LOGIN_OTP,
          otpData: result,
          otpMessage: message,
          otpModal: true,
        });
        yield put({
          type: actions.RESENDING_LOGIN_OTP,
          payload: false,
          isErrorVerifyOtp: false,
        });
      } else {
        yield put({
          type: actions.RESEND_LOGIN_OTP_FAILED,
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESEND_LOGIN_OTP_FAILED,
      });
    }
  });
}
export function* requestLoginOtp() {
  yield takeEvery('REQUEST_LOGIN_OTP', function* (payload) {
    try {
      yield put({
        type: actions.REQUESTING_LOGIN_OTP,
      });
      yield put({
        type: actions.KICKED_OUT_CLEAR,
      });
      yield put({
        type: actions.CLEAR_ERROR,
      });
      yield put({
        type: actions.SET_LOADING,
        loading: true,
      });
      const apiResult = yield requestingLoginOtp(payload.payload);
      if (apiResult) {
        const result = apiResult.data;
        if (result.success) {
          if (result.otp_banner) {
              yield put({
                type: actions.SET_OTP_BANNER,
                otp_banner: true,
                otp_email: result.email,
                otpMerchantId: result.merchant_id,
                user_id: result.user_id,
              });
              yield put({
                type: actions.SET_LOADING,
                loading: false,
              });
          } else {
            const message = `OTP successfully sent to ${result.data.email}`;
            yield put({
              type: actions.REQUESTED_LOGIN_OTP,
              otpData: result,
              otpModal: true,
              otpMessage: message,
            });
            yield put({
              type: actions.SET_LOADING,
              loading: false,
            });
          }
          // SAVE THE TOKEN OF THE USER FOR REQUEST USED
          yield put({
            type: actions.OTP_AUTH_TOKEN,
            payload: result.token,
          });
        } else {
          let errorResponse = '';
          if (result && result.message === 'Unauthorized') {
            errorResponse = 'INVALID_AUTH';
          } else if (result && result.message === 'Account not verified') {
            errorResponse = 'NOT_VERIFIED';
          } else if (result && result.message === 'Account Locked') {
            errorResponse = 'ACCOUNT_LOCKED';
          } else if (result && result.message === 'Password Expired') {
            errorResponse = 'PASSWORD_EXPIRED';
          } else if (result && result.message === 'Forbidden') {
            errorResponse = 'FORBIDDEN';
          } else {
            errorResponse = 'Login Error';
          }
          yield put({
            type: actions.LOGIN_ERROR,
            error: errorResponse,
          });
          yield put({
            type: actions.SET_LOADING,
            loading: false,
          });
        }
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: 'INVALID_AUTH',
        });
        yield put({
          type: actions.SET_LOADING,
          loading: false,
        });
      }
    } catch (error) {
      yield put({
        type: actions.LOGIN_ERROR,
        error: 'INVALID_AUTH',
      });
      yield put({
        type: actions.SET_LOADING,
        loading: false,
      });
    }
  });
}
export function* requestDeactivateOtp() {
  yield takeEvery('REQUEST_DEACTIVATE_OTP', function* ({payload}) {
    try {
      yield put({
        type: actions.REQUESTING_LOGIN_OTP,
      });
      yield put({
        type: actions.KICKED_OUT_CLEAR,
      });
      yield put({
        type: actions.CLEAR_ERROR,
      });
      yield put({
        type: actions.SET_LOADING,
        loading: true,
      });
      const apiResult = yield requestingDeactivateOtp(payload);
      if (apiResult) {
        const result = apiResult.data;
        if (result.success) {
          const message = `OTP successfully sent to ${result.data.email}`;
          yield put({
            type: actions.REQUESTED_LOGIN_OTP,
            otpData: result,
            otpModal: true,
            otpMessage: message,
          });
          yield put({
            type: actions.SET_LOADING,
            loading: false,
          });
        } else {
          let errorResponse = '';
          if (result && result.message === 'Unauthorized') {
            errorResponse = 'INVALID_AUTH';
          } else if (result && result.message === 'Account not verified') {
            errorResponse = 'NOT_VERIFIED';
          } else if (result && result.message === 'Account Locked') {
            errorResponse = 'ACCOUNT_LOCKED';
          } else if (result && result.message === 'Password Expired') {
            errorResponse = 'PASSWORD_EXPIRED';
          } else if (result && result.message === 'Forbidden') {
            errorResponse = 'FORBIDDEN';
          } else {
            errorResponse = 'Login Error';
          }
          yield put({
            type: actions.LOGIN_ERROR,
            error: errorResponse,
          });
          yield put({
            type: actions.ERROR_REQUEST_LOGIN_OTP,
          });
        }
      } else {
        yield put({
          type: actions.LOGIN_ERROR,
          error: 'INVALID_AUTH',
        });
      }
    } catch (error) {
      yield put({
        type: actions.ERROR_REQUEST_OTP,
      });
    }
  });
}

export function* fetchUserData() {
  yield takeEvery('FETCH_USER_DATA', function* ({payload}) {
    try {
      yield put({
        type: actions.FETCHING_USER_DATA,
      });
      const apiResult = yield fetchingUserData(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCHED_USER_DATA,
          payload: result.data,
          is_exist: result.is_exist,
          message: result.message ? result.message: 'Success fetching user data.',
        });
      } else {
        if (result.is_exist) {
          yield put({
            type: actions.FETCH_USER_DATA_FAILED,
            message: result.message,
            is_exist: result.is_exist,
          });
        } else {
          yield put({
            type: actions.FETCH_USER_DATA_FAILED,
            message: result.message,
            is_exist: result.is_exist,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_USER_DATA_FAILED,
        message: 'Error in requesting account deletion',
      });
    }
  });
}
export function* requestAccountDeletion() {
  yield takeEvery('REQUEST_ACCOUNT_DELETION', function* ({payload}) {
    try {
      yield put({
        type: actions.REQUESTING_ACCOUNT_DELETION,
      });
      const apiResult = yield requestingAccountDeletion(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REQUESTED_ACCOUNT_DELETION,
          payload: result.data,
        });
      } else {
        yield put({
          type: actions.REQUEST_ACCOUNT_DELETION_FAILED,
          message: result.message,
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_ACCOUNT_DELETION_FAILED,
        message: 'Error in requesting account deletion',
      });
    }
  });
}

export function* updatePassword() {
  yield takeEvery('UPDATE_PASSWORD', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATE_PASSWORD_LOADING,
      });
      const identity = yield select(state => state.Auth.identity);
      const apiResult = yield updatePasswordRequest(payload, identity);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_PASSWORD_SUCCESS,
          payload: result,
        });
        if (payload.loginRequired) {
          window.location.href = `${process.env.REACT_APP_BASE_URL}signin`
        }
      } else {
        yield put({
          type: actions.UPDATE_PASSWORD_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_PASSWORD_FAILED,
        payload: error,
      });
    }
  })
}

export function* requestOtpUpdatePassword() {
  yield takeEvery('REQUEST_OTP_UPDATE_PASSWORD', function* ({payload}) {
    try {
      yield put({
        type: actions.REQUEST_OTP_UPDATE_PASSWORD_LOADING,
      });
      const identity = yield select(state => state.Auth.identity);
      const apiResult = yield requestOtpUpdatePasswordRequest(payload, identity);
      const result = apiResult.data;
      if (result.success && result.data?.success) {
        yield put({
          type: actions.REQUEST_OTP_UPDATE_PASSWORD_SUCCESS,
          payload: result.data.data
        });
      } else {
        yield put({
          type: actions.REQUEST_OTP_UPDATE_PASSWORD_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_OTP_UPDATE_PASSWORD_FAILED,
        payload: error,
      });
    }
  });
}

export function* validateOtpUpdatePassword() {
  yield takeEvery('VALIDATE_OTP_UPDATE_PASSWORD', function* ({payload}) {
    try {
      yield put({
        type: actions.VALIDATE_OTP_UPDATE_PASSWORD_LOADING,
      });
      const identity = yield select(state => state.Auth.identity);
      const apiResult = yield validateOtpUpdatePasswordRequest(payload, identity);
      const result = apiResult.data;
      if (result.success && result.data?.success) {
        yield put({
          type: actions.VALIDATE_OTP_UPDATE_PASSWORD_SUCCESS,
          payload: result.data
        });
      } else {
        yield put({
          type: actions.VALIDATE_OTP_UPDATE_PASSWORD_FAILED,
          payload: apiResult,
        });
      }
    } catch (error) {
      yield put({
        type: actions.VALIDATE_OTP_UPDATE_PASSWORD_FAILED,
        payload: error,
      });
    }
  });
}

export function* forgotPasswordViaEmail() {
  yield takeEvery('RESET_FORGOT_PASSWORD', function* ({ payload }) {

    try {
      yield put({
        type: actions.RESET_FORGOT_PASSWORD_LOADING,
      });

      const apiResult = yield forgotPasswordViaEmailRequest(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.RESET_FORGOT_PASSWORD_SUCCESS,
          payload: result,
        });
      } else {
        yield put({
          type: actions.RESET_FORGOT_PASSWORD_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESET_FORGOT_PASSWORD_FAILED,
        payload: error,
      });
    }
  });
}

export function* resetPortalUserPassword() {
  yield takeEvery('RESET_PORTAL_USER_PASSWORD', function* ({payload}) {
    try {
      yield put({
        type: actions.RESET_PORTAL_USER_PASSWORD_LOADING,
      });
      const identity = yield select(state => state.Auth.identity);
      const apiResult = yield resetPortalUserPasswordRequest(payload, identity);
      const result = apiResult.data;
      if(result.success) {
        yield put({
          type: actions.RESET_PORTAL_USER_PASSWORD_SUCCESS,
          payload: apiResult,
        });
      }else {
        yield put({
          type: actions.RESET_PORTAL_USER_PASSWORD_FAILED,
          payload: apiResult,
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESET_PORTAL_USER_PASSWORD_FAILED,
        payload: error,
      });
    }
  })
}


export function* expiredPasswordUpdate() {
  yield takeEvery('EXPIRED_PASSWORD', function* ({payload}) {
    try {
      yield put({
        type: actions.EXPIRED_PASSWORD_LOADING,
      });
      const apiResult = yield expiredPasswordRequest(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EXPIRED_PASSWORD_SUCCESS,
          payload: result,
        });
      } else {
        yield put({
          type: actions.EXPIRED_PASSWORD_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.EXPIRED_PASSWORD_FAILED,
        payload: {
          success: false,
        },
      });
    }
  });
}


export function* forgotUsernameRequestOtp() {
  yield takeEvery('FORGOT_USERNAME_REQUEST_OTP', function* ({payload}) {
    try {
      yield put({
        type: actions.FORGOT_USERNAME_REQUEST_OTP_LOADING,
      });
      const apiResult = yield forgotUsernameRequestOtpRequest(payload);
      const result = apiResult.data;
      if(result.success) {
        yield put({
          type: actions.FORGOT_USERNAME_REQUEST_OTP_SUCCESS,
          payload: result,
        });
      } else {
        yield put({
          type: actions.FORGOT_USERNAME_REQUEST_OTP_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FORGOT_USERNAME_REQUEST_OTP_FAILED,
        payload: {
          success: false,
        },
      });
    }
  });
}

export function* forgotUsernameValidateOtp() {
  yield takeEvery('FORGOT_USERNAME_VALIDATE_OTP', function* ({payload}) {
    try {
      yield put({
        type: actions.FORGOT_USERNAME_VALIDATE_OTP_LOADING,
      });
      const apiResult = yield forgotUsernameValidateOtpRequest(payload);
      const result = apiResult.data;
      if(result.success) {
        yield put({
          type: actions.FORGOT_USERNAME_VALIDATE_OTP_SUCCESS,
          payload: result,
        });
      } else {
        yield put({
          type: actions.FORGOT_USERNAME_VALIDATE_OTP_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FORGOT_USERNAME_VALIDATE_OTP_FAILED,
        payload: {
          success: false,
        },
      });
    }
  });
}

export function* retrieveUsername() {
  yield takeEvery('RETRIEVE_USERNAME_VIA_EMAIL', function* ({payload}) {
    try {
      yield put({
        type: actions.RETRIEVE_USERNAME_VIA_EMAIL_LOADING,
      });
      const apiResult = yield retrieveUsernameViaEmail(payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.RETRIEVE_USERNAME_VIA_EMAIL_SUCCESS,
          payload: result,
        });
      } else {
        yield put({
          type: actions.RETRIEVE_USERNAME_VIA_EMAIL_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.RETRIEVE_USERNAME_VIA_EMAIL_FAILED,
        payload: error,
      });
    }
  });
}

export function* fetchIntegAuth() {
  yield takeEvery('FETCH_INTEG_AUTH', function* ({payload}) {
    try {
      yield put({
        type: actions.FETCH_INTEG_AUTH_LOADING,
      });
      const apiResult = yield getIntegAuthRequest(payload);
      const response = apiResult.data;
      if (apiResult.status === 200 && response.data) {
        yield put({
          type: actions.FETCH_INTEG_AUTH_SUCCESS,
          payload: response.data,
        });
      } else {
        yield put({
          type: actions.FETCH_INTEG_AUTH_FAILED,
          payload: response,
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_INTEG_AUTH_FAILED,
        payload: error,
      });
    }
  });
}

export function* saveIntegAuth() {
  yield takeEvery('SAVE_INTEG_AUTH', function* ({payload}) {
    try {
      yield put({
        type: actions.SAVE_INTEG_AUTH_LOADING,
      });
      const apiResult = yield saveIntegAuthRequest(payload);
      const response = apiResult.data; 
      if (apiResult.status === 200 && response.data) {
        yield put({
          type: actions.SAVE_INTEG_AUTH_SUCCESS,
          payload: response.data,
        });
      } else {
        yield put({
          type: actions.SAVE_INTEG_AUTH_FAILED,
          payload: response,
        });
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_INTEG_AUTH_FAILED,
        payload: error,
      });
    }
  });
}

export function* requestOtpIntegAuth() {
  yield takeEvery('REQUEST_OTP_INTEG_AUTH', function* ({payload}) {
    try {
      yield put({
        type: actions.REQUEST_OTP_INTEG_AUTH_LOADING,
      });
      const apiResult = yield requestOtpIntegAuthRequest(payload);
      const result = apiResult.data;
      if (result.success && result.data?.success) {
        yield put({
          type: actions.REQUEST_OTP_INTEG_AUTH_SUCCESS,
          payload: result.data
        });
      } else {
        yield put({
          type: actions.REQUEST_OTP_INTEG_AUTH_FAILED,
          payload: apiResult,
        });
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_OTP_INTEG_AUTH_FAILED,
        payload: error,
      });
    }
  });
}

export function* validateOtpIntegAuth() {
  yield takeEvery('VALIDATE_OTP_INTEG_AUTH', function* ({payload}) {
    try {
      yield put({
        type: actions.VALIDATE_OTP_INTEG_AUTH_LOADING,
      });
      const apiResult = yield validateOtpIntegAuthRequest(payload);
      const result = apiResult.data;
      if (result.success && result.data?.success) {
        yield put({
          type: actions.VALIDATE_OTP_INTEG_AUTH_SUCCESS,
          payload: result.data
        });
      } else {
        yield put({
          type: actions.VALIDATE_OTP_INTEG_AUTH_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.VALIDATE_OTP_INTEG_AUTH_FAILED,
        payload: error,
      });
    }
  });
}

export function* revealIntegAuthCredentials() {
  yield takeEvery('REVEAL_INTEG_AUTH_CREDS', function* ({id, payload}) {
    try {
      yield put({
        type: actions.REVEAL_INTEG_AUTH_CREDS_LOADING,
      });    
      const apiResult = yield revealIntegAuthCredentialsRequest(id, payload);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REVEAL_INTEG_AUTH_CREDS_SUCCESS,
          payload: result
        });
      } else {
        yield put({
          type: actions.REVEAL_INTEG_AUTH_CREDS_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.REVEAL_INTEG_AUTH_CREDS_FAILED,
        payload: error,
      });
    }
  })
}

export function* resetMkey() {
  yield takeEvery('RESET_MKEY', function* ({id}) {
    try {
      yield put({
        type: actions.RESET_MKEY_LOADING,
      });    
      const apiResult = yield resetMkeyRequest(id);
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.RESET_MKEY_SUCCESS,
          payload: result
        });
      } else {
        yield put({
          type: actions.RESET_MKEY_FAILED,
          payload: result,
        });
      }
    } catch (error) {
      yield put({
        type: actions.RESET_MKEY_FAILED,
        payload: error,
      });
    }
  })
}


export function* validateResetExpiredPassword() {
  yield takeEvery('VALIDATE_RESET_EXPIRED_PASSWORD', function* (){
    try {
      yield put({
      type: actions.VALIDATE_RESET_EXPIRED_PASSWORD_LOADING,
    });
    const apiResult = yield validateResetExpiredPasswordRequest();
    const result = apiResult.data;
    if (result.success) {
      yield put({
        type: actions.VALIDATE_RESET_EXPIRED_PASSWORD_SUCCESS,
        payload: result
      });
    } else {
      yield put({
        type: actions.VALIDATE_RESET_EXPIRED_PASSWORD_FAILED,
        payload: result,
      });
    }
    } catch (error) {
      yield put({
        type: actions.VALIDATE_RESET_EXPIRED_PASSWORD_FAILED,
        payload: error,
      });
    }
  })
}

export function* requestOtp() {
  yield takeEvery('CUSTOM_REQUEST_OTP', function* ({payload}){
    try {
      yield put({
        type: actions.CUSTOM_REQUEST_OTP_LOADING,
      });

      const token = yield select(state =>state.Auth.idToken);
      const apiResult = yield requestOtpRequest(payload, token);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CUSTOM_REQUEST_OTP_SUCCESS,
          payload: result.data
        });
      } else {
        yield put({
          type: actions.CUSTOM_REQUEST_OTP_FAILED,
          payload: result,
        });
        
        if (payload.purpose === 'LOGIN') {
          let errorResponse = '';

          switch (result.response_advise) {
            case 'Account is not verified':
              errorResponse = 'NOT_VERIFIED';
              break;
            case 'Account is locked':
              errorResponse = 'ACCOUNT_LOCKED';
              break;
            case 'Password is expired':
              errorResponse = 'PASSWORD_EXPIRED';
              break;
            default:
              errorResponse = 'INVALID_AUTH';
              break;
          }

          yield put({
            type: actions.LOGIN_ERROR,
            error: errorResponse,
          });

          yield put({
            type: actions.SET_SHOW_OTP_MODAL,
            payload: false,
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CUSTOM_REQUEST_OTP_FAILED,
        payload: error,
      });
    }
  })
}

function expiredPasswordRequest(data) {
  return post(`/authenticate/expired_password_update`, data);
}
function fetchingUserData(data) {
  return fetch(`${apiUrl}authenticate/fetch_user_data`, {
    headers: headers,
    method: 'POST',
    data,
  });
}
function requestingAccountDeletion(data) {
  return fetch(`${apiUrl}authenticate/account_deletion`, {
    headers: headers,
    method: 'POST',
    data,
  });
}
function login(data) {
  // this.checkToken();
  return fetch(`${apiUrl}authenticate?otpCode=${data.otpCode}&requestId=${data.requestId}`, {
    headers: headers,
    method: 'POST',
    data: data.data
  });
}

function signup(data) {
  // this.checkToken();
  return fetch(`${apiUrl}registrationbizaccounts/pre_register`, {
    headers: headers,
    method: 'POST',
    data,
  });
}

function fetchRedirectUrl() {
  return fetch(`${apiUrl}redirect_url/get_redirect_url`, {
    headers: headers,
    method: 'get',
  });
}

function fetchModules(token) {
  // this.checkToken();
  return get(`system/${systemId}/modules`, null, null, null, token);
}

function fetchStores(token, mid) {
  // this.checkToken();
  return get(`stores/ui/get_store_by_mid/${mid}`, null, null, null, token);
}

function searchStores(data, token, mid) {
  return post(`stores/search_store_by_text/${mid}`, data, null, null, null, token);
}

function fetchAllRoles(token) {
  // this.checkToken();
  return get(`roles/fetch/store_roles`, null, null, null, token);
}

function forgotPasswordReq(email) {
  // this.checkToken();
  return get(`resettokens/get_id_by_email/${email}`);
}

function fetchAllMerchant(token) {
  // this.checkToken();
  return get(`merchants/get_all_merchants`, null, null, null, token);
}

function fetchSubMerchants(id, token) {
  // this.checkToken();
  return get(`merchants/get_sub_merchants/${id}`, null, null, null, token);
}
function resendSuccesRegEmail(data) {
  return fetch(`${apiUrl}registrationbizaccounts/resend_email`, {
    headers: headers,
    method: 'POST',
    data,
  });
}

function resendSuccesBatchUploadRegEmail(data) {
  return fetch(`${apiUrl}registrationbizaccounts/resend_email_batch_upload`, {
    headers: headers,
    method: 'POST',
    data,
  });
}

function fetchResetPassUrl() {
  return fetch(`${apiUrl}redirect_url/get_reset_password_url`, {
    headers: headers,
    method: 'get',
  });
}

function requestingLoginOtp(data) {
  return post(`onetimepasswords/request`, data);
}
function requestingDeactivateOtp(data) {
  return post(`onetimepasswords/request`, data);
}
function verifyingOtp(data) {
  return post(`onetimepasswords/validate`, data);
}
function resendingOtp(data) {
  return post(`onetimepasswords/resend_otp`, data);
}

function saveAgreeOtp(id, data, token) {
  return putOtp(`users/save_agree_otp/${id}`, data, token);
}

function fetchDisabledModules(id) {
  // this.checkToken();
  return get(`disablemodules/get_by_tenant/${id}`);
}

function fetchFeesByTenant(token) {
  return get(`merchantpchannelfees/`, null, null, null, token);
}

function fetchFeesByTenantMid(id, token) {
  return get(`merchantpchannelfees/fetch_by_tenant_mid/${id}`, null, null, null, token);
}

// function fetchMerchantByMid(mid) {
//   return get(`merchants/get_by_mid/${mid}`);
// }

// function fetchPchannels(mid) {
//   return get(`merchantchannels/get_pchannels_by_mid/${mid}`);
// }

// function fetchUser(id) {
//   return get(`users/get_user_and_store/${id}`)
// }

function updatePasswordRequest(payload, identity) {
  return identity && !payload.isExpired ?
    post(`authenticate/update_password_new?otpCode=${payload.otpCode}&requestId=${payload.requestId}`, payload.data)
    :
    encryptedPost(`authenticate/update_password_new_encrypted`, payload)
}

function requestOtpUpdatePasswordRequest(payload, identity) {
  return identity ?
    post(`onetimepasswords/request_otp/update_password`, payload)
    :
    encryptedPost('onetimepasswords/request_otp/update_password/encrypted', payload)
}

function validateOtpUpdatePasswordRequest(payload, identity) {
  return identity ? 
    post(`onetimepasswords/validate_otp/update_password`, payload)
    :
    encryptedPost(`onetimepasswords/validate_otp/update_password/encrypted`, payload);
}

function resetPortalUserPasswordRequest(payload, identity) {
  return identity ?
    post(`authenticate/reset_password_by_email`, payload)
    :
    encryptedPost(`authenticate/reset_password_by_email_encrypted`, payload)
}

function forgotPasswordViaEmailRequest(payload) {
  return encryptedPost(
      `authenticate/reset_password_by_email_encrypted?otpCode=${payload.otpCode}&requestId=${payload.requestId}`,
      payload.data
  );
}

function forgotUsernameRequestOtpRequest(payload) {
  return encryptedPost(`onetimepasswords/request/username`, payload);
}

function forgotUsernameValidateOtpRequest(payload) {
  return encryptedPost(`onetimepasswords/validate/username`, payload);
}

function retrieveUsernameViaEmail(payload) {
  return encryptedPost(
    `authenticate/retrieve_username_via_email?otpCode=${payload.otpCode}&requestId=${payload.requestId}`,
    payload.data
  );
}

function getIntegAuthRequest(mid) {
  return kotlinApiGet(`integration_auth/fetch_by_mid/${mid}`);
}

function saveIntegAuthRequest(payload) {
  return kotlinApiPost(`integration_auth/save?otpCode=${payload.otpCode}&requestId=${payload.requestId}`, payload.data);
}

function requestOtpIntegAuthRequest(payload) {
  return kotlinApiPost(`onetimepassword/request/integauth`, payload);
}

function validateOtpIntegAuthRequest(payload) {
  return kotlinApiPost(`onetimepassword/validate/integauth`, payload);
}

function revealIntegAuthCredentialsRequest(payload) {
  return kotlinApiPost(`integration_auth/reveal_credentials?otpCode=${payload.otpCode}&requestId=${payload.requestId}`, payload.data)
}

function resetMkeyRequest(payload) {
  return kotlinApiPut(`integration_auth/reset_mkey?otpCode=${payload.otpCode}&requestId=${payload.requestId}`, payload.data)
}

function validateResetExpiredPasswordRequest() {
  return kotlinApiEncryptedGet('auth/validate_reset_expired_password')
}

function requestOtpRequest(payload, token) {
  if(token) {
    return kotlinApiPost(`onetimepassword/request/authenticated/${payload.purpose}`, payload.data)
  } else {
    return kotlinApiPost(`onetimepassword/request/${payload.purpose}`, payload.data)
  }
}

export function* listenToSSE() {
  const sse = SSEManager.getInstance();
  const channel = eventChannel((emit) => {
    const unsubscribe = sse.listen((event) => {
      emit(event);
    });
    return unsubscribe;
  });

  try {
    while (true) {
      const event = yield take(channel);
      if (event?.type !== "SSE_EVENT") {
        continue;
      }
      const data = event.data;
      if (!data?.type) {
        continue;
      }
      switch (data.type) {
        case "download_transaction":
        case "download_withdraw":
        case "download_splitpay":
        case "download_topup":
        case "download_biz_wallet":
        case "download_merchant_transaction":
        case "download_auto_settlement":
        case "download_store_transaction":
        case "download_paybiz_channel":
          yield put({
            type: merchantAction.UPDATE_RECENT_EXPORT_JOB,
            payload: data.data,
          });
          break;
        default:
          break;
      }
    }
  } finally {
    channel.close();
  }
}
 

export default function* rootSaga() {
  yield all([
    fork(checkAuthorization),
    fork(loginRequest),
    fork(signupRequest),
    fork(forgotPassword),
    fork(forgotPasswordViaEmail),
    fork(loginSuccess),
    fork(subModuleLoad),
    fork(loginError),
    fork(logout),
    fork(kickedOutClear),
    fork(changeMerchant),
    fork(fetchStore),
    fork(changeMerchantSuccess),
    fork(getRedirectUrl),
    fork(resendRegistrationEmail),
    fork(getResetPassUrl),
    fork(resendRegistrationBatchUploadEmail),
    fork(searchStoreData),
    fork(fetchStoreDataV2),
    fork(agreeOtp),
    fork(requestLoginOtp),
    fork(requestDeactivateOtp),
    fork(verifyOtp),
    fork(resendLoginOtp),
    fork(fetchUserData),
    fork(requestAccountDeletion),
    fork(updatePassword),
    fork(requestOtpUpdatePassword),
    fork(validateOtpUpdatePassword),
    fork(retrieveUsername),
    fork(resetPortalUserPassword),
    fork(expiredPasswordUpdate),
    fork(forgotUsernameRequestOtp),
    fork(forgotUsernameValidateOtp),
    fork(fetchIntegAuth),
    fork(saveIntegAuth),
    fork(requestOtpIntegAuth),
    fork(validateOtpIntegAuth),
    fork(revealIntegAuthCredentials),
    fork(resetMkey),
    fork(validateResetExpiredPassword),
    fork(requestOtp),
  ]);
}
